export const isLogin = () => {
    if (localStorage.getItem('AUTH_TOKEN')) return true;
    return false;
}